import React from 'react';
import { Button, Card, CardBody, Input, Col, Row } from 'reactstrap';
import { ModalDoctor } from '../../components/doctors/ModalDoctor';
import { TableStriped } from '../../components/tables/TableStriped';
import { useDoctors } from '../../hooks/doctors/useDoctors';
import { TabDoctor } from '../../constant';
import { cedimi, demo } from '../../constant/globalConstantsTypeClients'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DialogSendEmail } from './DialogSendEmail';
import { TitleDataTable } from '../../components/tableDataTable/TitleDataTable';
import { DialogImgMicrosite } from './DialogImgMicrosite';

export const IndexDoctors = ({ activeTab }) => {

    const {

        goNextPage, goPreviousPage, goToPage, actualPage, totalPages, dataDoctor, handleSearch,
        handleUpdate, handleDelete, handleCreate, saveCreate, saveDelete, handleInputChange, id_specialty, name, professional_license, phone, address, email, code,
        validaciones, nameInputs, saveUpdate,
        specialties, toggle, loading, method, modal, name_specialty, isCommercialPartner, username, password_microsite, generateRandomPassword, downloadExcel, id_seller,
        listSellers, handleSelectValuesA, handleSendEmail, toggleEmail, modalEmail, saveEmailDoctor, validacionesEmail, closeModalDoctor, searchQuery, handleClearFilter,
        handleCreateMicrosite, closeDialog, modalMicrosite, uploadImage, validateAndUpload, MAX_SIZE, 
        //? WHATSAPP DOCTOR
        whatsapp_doctor, handleWhatsappDoctorChange, validateWhatsappDoctor
    } = useDoctors({ activeTab });

    let _typeClient = localStorage.getItem('url_helen');


    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                {rowData.isCommercialPartner && (
                    <button
                        type="button"
                        onClick={() => handleSendEmail(rowData.id_doctor)}
                        style={{
                            padding: "2px",
                            fontSize: "1rem",
                            height: "26px",
                            width: "26px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#ffb900",
                            border: "none",
                            color: "#fff"
                        }}
                        title="Enviar a correo"
                    >
                        <i className="icofont icofont-envelope" />
                    </button>
                )}

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_doctor)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_doctor)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    let _microsite = localStorage.getItem('configuration_microsite');





    return (
        <>
            <Card>
                <CardBody className="p-1">
                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                        <TitleDataTable
                            titleTable={TabDoctor}
                            buttonActions={downloadExcel}
                            titleButton="Descargar listado médicos"
                            isDisbled={false}
                            titleCreate="Crear Médico"
                            buttonActionsCreate={handleCreate}
                            actionInput={handleSearch}
                            valueFilter={searchQuery}
                            filterLocalStorage={true}
                            cleanFilterLocalStorage={handleClearFilter}
                            {...(_microsite === "True" && {
                                microsite: true,
                                titleButtonMicrosite: "Imagen para micrositio (Login)",
                                buttonMicrosite: handleCreateMicrosite
                            })}

                        />
                    </Col>

                    <Col sm="12">
                        <div className="table-responsive">
                            <DataTable
                                value={dataDoctor}
                                lazy
                                paginator
                                first={(actualPage - 1) * 10}
                                rows={10}
                                totalRecords={totalPages * 10}
                                onPage={(e) => goToPage(e.page + 1)}
                                // rowsPerPageOptions={[10, 20, 50]} 
                                className="data-table p-datatable-striped p-datatable-sm"
                                responsiveLayout="scroll"
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "45%" }}
                                            alt="Sin resultados"
                                        />
                                        <br />
                                        <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                            No hay coincidencias con la búsqueda.
                                        </p>
                                    </div>
                                }
                            >

                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                <Column field="name" header="Nombre" headerStyle={headerStyle} style={centerStyle} />
                                <Column field="email" header="Correo" body={(rowData) => rowData.email ? rowData.email : "--"} headerStyle={headerStyle} style={centerStyle} />
                                <Column field="phone" header="Teléfono" body={(rowData) => rowData.phone ? rowData.phone : "--"} headerStyle={headerStyle} style={centerStyle} />
                                {
                                    _typeClient === cedimi && (
                                        <Column field="whatsapp_doctor" header="No. WhatsApp" body={(rowData) => rowData.whatsapp_doctor ? rowData.whatsapp_doctor : "--"} headerStyle={headerStyle} style={centerStyle} />
                                    )
                                }
                                <Column field="code" header={_typeClient === cedimi ? "No. Colegiado" : "Código"} body={(rowData) => rowData.code ? rowData.code : "--"} headerStyle={headerStyle} style={centerStyle} />
                                <Column field="name_specialty" header="Especialidad" headerStyle={headerStyle} style={centerStyle} />
                                {
                                    _typeClient === cedimi || _typeClient === demo ? (
                                        <Column
                                            header="Representante / Vendedor visita médica"
                                            body={(rowData) => {
                                                const seller = listSellers.find(
                                                    s => s.value === rowData.id_seller
                                                );
                                                return seller ? seller.label : "--";
                                            }}
                                            headerStyle={headerStyle}
                                            style={centerStyle}
                                        />
                                    ) : (
                                        <Column
                                            field="professional_license"
                                            header="Cédula Profesional"
                                            body={(rowData) =>
                                                rowData.professional_license
                                                    ? rowData.professional_license
                                                    : "--"
                                            }
                                            headerStyle={headerStyle}
                                            style={centerStyle}
                                        />
                                    )
                                }

                                <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                            </DataTable>
                        </div>
                    </Col>
                </CardBody>
            </Card>
            <br /><br />

            <ModalDoctor
                {
                ...{
                    method,
                    handleInputChange, validaciones, nameInputs,
                    specialties, id_specialty, name, professional_license,
                    phone, address, email, code,
                    toggle, modal, loading,
                    saveCreate, saveUpdate, saveDelete, name_specialty, isCommercialPartner, username, password_microsite, generateRandomPassword,
                    id_seller, listSellers, handleSelectValuesA, closeModalDoctor, whatsapp_doctor, handleWhatsappDoctorChange, validateWhatsappDoctor
                }
                }
            />

            <DialogSendEmail
                {
                ...{ toggleEmail, email, handleInputChange, loading, modalEmail, saveEmailDoctor, validacionesEmail }
                }
            />

            <DialogImgMicrosite
                {
                ...{ closeDialog, modalMicrosite, uploadImage, validateAndUpload, MAX_SIZE }
                }
            />


        </>
    )
}
